import { registerCapability } from '../../platform/capability-registry';
import { EnvVarsBlock } from './EnvVarsBlock';
import { ENV_VARS_ACTION_KEY_LIST, ENV_VARS_FIELD_KEY_LIST } from './fieldKeys';
import { resolveEnvVarsPaths } from './resolvePaths';
import type { EnvVarsBlockOptions } from './types';

registerCapability<EnvVarsBlockOptions>({
  key: 'env-vars',
  fields: [...ENV_VARS_FIELD_KEY_LIST],
  actions: [...ENV_VARS_ACTION_KEY_LIST],
  component: EnvVarsBlock,
  defaultPaths: (prefix) => resolveEnvVarsPaths(prefix),
  resolvePaths: (prefix, options) => resolveEnvVarsPaths(prefix, options),
});
